import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'react-bootstrap';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import InputEditAble from 'components/inputEditAble';
import ConfirmCancel from './confirm-cancel';

import {isEmpty} from 'lodash';
import { v4 as uuidv4 } from 'uuid';

import delete_icon from 'assets/img/delete.svg';
import { CheckBox } from '../../../components/checkboxes/check-box';
import RFSSignoffModal from './rfs-signoff-confirm-modal';

class TemplateEOCAdd extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    onCreateCustomTemplate: PropTypes.func,
    getDefaultTemplate: PropTypes.func,
    builderName: PropTypes.string
  };

  constructor(props) {
    super(props);
    const defaultDisclaimer =
    `Congratulation and welcome to your new home! Please read carefully. Your signature below acknowledges the following:

1. That you understand and accept the policies highlighted here and detailed in your on-line homeowners manual.

2. That you have inspected your new home and that all corrections are recorded on page 2 of this orientation form.

3. That all commitments are in writing on these forms. No verbal commitments have been made.

HOMEOWNER’S ACCEPTANCE OF NEW HOME EXCEPT AS NOTED ABOVE, I/WE ACCEPT THIS HOME AS PRESENTED BY ${this.props.builderName}, AND ACKNOWLEDGE THAT AFTER MOVE-IN ANY COSMETIC DAMAGES WILL BE YOUR RESPONSIBILITY AS A HOMEOWNER.`;
    this.state = {
      openCustomTemplate: false,
      openEditTemplate: false,
      checked: false,
      editTitle: false,
      customTemplate: {
        name: 'Untitled template',
        sections: [
        {id: uuidv4(),
        title: 'Are you sure you want to allow RFS SignOff without the WO being resolved or closed?',
        type: 1,
        value: false,
        items:[]}
        ],
        disclaimerText: defaultDisclaimer,
        EofStatus :false
      },
      openConfirmModal: false,
      openModalConfirm: false,
      openRFSSignoffConfirmModal:false,
      isAllowRfsSignoff:false
    };
  }

  onClose = () => {
    this.props.onClose();
  };

  onCloseAndGetList = () => {
    this.props.onClose();
    this.props.getDefaultTemplate();
  }
  onRFSSignoffConfirm = () =>{
    this.setState({
      openRFSSignoffConfirmModal: false
    });
  }
  onCancelConfirmModal = () => {
  let { customTemplate } = this.state;
    var index = customTemplate.sections.findIndex((obj,index) => obj.id === customTemplate.sections[index].id);
  customTemplate.sections[index].value = false;
      this.setState({openRFSSignoffConfirmModal: false, customTemplate: customTemplate,openConfirmModal: false,openModalConfirm: !this.state.openModalConfirm, });
  }

  isInvalidTemplate() {
    const { customTemplate } = this.state;

    if (customTemplate.sections.length === 0) {
      return true;
    }

    if (customTemplate.sections.some(s => !s.items.some(i => i.content && i.content.length > 0))) {
      return true;
    }

    return false;
  }

  // Display section list of template
  onAddNewSectionBtnClick = () => {
    let { customTemplate } = this.state;
    customTemplate.sections.push({
      id: uuidv4(),
      title: 'Untitled checklist',
      items: [],
      type:0,
      value:false
    });

    this.setState({openCustomTemplate: true, customTemplate: customTemplate });
  };

  createTemplate = () => {
    const { customTemplate } = this.state;
    let submittedSections = customTemplate.sections.map(section => {
      return {
        title: section.title,
        type: section.type,
        value:section.value?1:0,
        items: section.items && section.items.filter(item => item.content !== null && item.content.length > 0),
      };
    });

    this.setState({ customTemplate: {...customTemplate, sections: submittedSections }}, () => {
      this.props.onCreateCustomTemplate({
        data: this.state.customTemplate
      }, () => this.onCloseAndGetList());
    });

  }

  onEnterItemBtnClick = sectionIndex => {
    let { customTemplate } = this.state;
    customTemplate.sections[sectionIndex].items.push({
      id: uuidv4(),
      content: null
    });

    this.setState({ customTemplate: customTemplate });
  };

  onRemoveItem = (sectionIndex, index) => {
    let { customTemplate } = this.state;

    customTemplate.sections[sectionIndex].items.splice(index, 1);
    this.setState({ customTemplate: customTemplate});
  };

  onRemoveSection = (sectionIndex) => {
    let { customTemplate } = this.state;

    customTemplate.sections.splice(sectionIndex, 1);
    this.setState({ customTemplate: customTemplate});
  };

  onEditTemplateTitle = (value) => {
    let { customTemplate } = this.state;

    this.setState({customTemplate: {...customTemplate, name: value}});
  }

  onEditSectionTitle = (index, value) => {
    let { customTemplate } = this.state;

    customTemplate.sections[index].title = value;
    this.setState({ customTemplate: customTemplate });
  }

  onEditItemContent = (sectionIndex, index, value) => {
    let { customTemplate } = this.state;

    customTemplate.sections[sectionIndex].items[index].content = value;
    this.setState({ customTemplate: customTemplate });
  }

  onEditDisclaimer = (value) => {
    let {customTemplate} = this.state;
    if (isEmpty(value) || isEmpty(value[Object.keys(value)[0]])) {
      // this.setState({ errorMsg: 'This Field is required'});
    } else {
      customTemplate.disclaimerText = value['disclaimerText'];
      this.setState({customTemplate: customTemplate, errorMsg: null});
    }
  }

  toolTipDisclaimer() {
    return (
      <Tooltip className='in tooltip-siteone' id='disable-go-to'>
        <span>This disclaimer is put right above the signature section in the form.</span>
      </Tooltip>
    );
  }

  renderSections = () => {
    const { customTemplate } = this.state;

    return (
      customTemplate.sections.map((section, index) => {
        return (
          <div key={section.id} className='custom-template-section-item'>
            {section&&section.type === 0 &&
            <div className='top-section'>
              <div className='section-items'>
                <div className='col-xs-11' style={{ top: '5px' }}>
                  <input name={section.id} className='form-control custom-template-name'
                    placeholder='Untitled Checklist' autoComplete='off' maxLength='254' value={section.title}
                    onBlur={() => section.title || this.onEditSectionTitle(index, 'Untitled Checklist') }
                    onChange={ (e) => this.onEditSectionTitle(index, e.target.value) }/>
                </div>
                <div className='col-xs-1' style={{lineHeight: '46px', textAlign: 'center'}}>
                  <img src={delete_icon} style={{width: 20, cursor: 'pointer'}} onClick={() => this.onRemoveSection(index)}/>
                </div>
              </div>
              { this.renderSectionItems(section, index)}
              <div className='bottom-section'>
                <div className='col-xs-12'>
                  <span onClick={() => this.onEnterItemBtnClick(index)}>Enter item</span>
                </div>
              </div>
            </div>
            }
          </div>
        );
      })
    );
  }

  renderSectionItems = (section, sectionIndex) => {
    if (section.items.length === 0) {
      return '';
    }
    return (
      section.items.map((item, index) => {
        return (
          <div key={item.id} className='bottom-section clearfix'>
            <div style={{ top: 5 }} className='col-xs-1'>
              <span>{index + 1}. </span>
            </div>
            <div style={{ bottom: '10px', right: '10px' }} className='col-xs-9'>
              <div className='item-section-edit'>
                <textarea name={section.id + '|' + item.id} className='form-control' maxLength='254' value={item.content}
                  onChange={ (e) => this.onEditItemContent(sectionIndex, index, e.target.value) }/>
              </div>
            </div>
            <div className='col-xs-2' style={{ lineHeight: '36px' }}>
              <img src={delete_icon} style={{width: 16, cursor: 'pointer'}} onClick={() => this.onRemoveItem(sectionIndex, index)}/>
            </div>
          </div>
        );
      })
    );
  };

  onChecked=(e, data)=>{
    let { customTemplate } = this.state;
    if(customTemplate.sections.length > 0){
      var index = customTemplate.sections.findIndex((obj,index) => obj.id === customTemplate.sections[index].id);
      customTemplate.sections[index].value = !customTemplate.sections[index].value;
      if(!data){
        this.setState({openRFSSignoffConfirmModal: true, customTemplate: customTemplate });
      }else{
        this.setState({openRFSSignoffConfirmModal: false, customTemplate: customTemplate });
      }
    }else{
      customTemplate.sections.push({
      id: uuidv4(),
      title: 'Are you sure you want to allow RFS SignOff without the WO being resolved or closed?',
      type: 1,
      value: true,
      items:[]
      }); 

      if(!data){
        this.setState({openRFSSignoffConfirmModal: true, customTemplate: customTemplate });
      }else{
        this.setState({openRFSSignoffConfirmModal: false, customTemplate: customTemplate });
      }
    }

  }
  
  render() {
    // const isInvalidTemplate = this.isInvalidTemplate();

    const { openCustomTemplate, customTemplate } = this.state;
    const isAllowRfsSignoff = customTemplate.sections.find((obj, index ) => obj.id === customTemplate.sections[index].id)
    return (
      <Modal scrollable='true' centered='true' dialogClassName='template-eoc-dialog' show={true}>
        <div style={{ margin: 10 }}>
          <Modal.Header>
            <div className='container-fluid'>
              <div className='title-custom-template row'>
                <input
                  name='model'
                  className='form-control'
                  placeholder='Untitled template'
                  autoComplete='off'
                  maxLength='254'
                  value={customTemplate.name}
                  onBlur={() => customTemplate.name || this.onEditTemplateTitle('Untitled Template') }
                  onChange={(e) => this.onEditTemplateTitle(e.target.value)}/>
              </div>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className='container-fluid'>
            <div className='row' style={{marginTop: '10px', marginBottom: '10px'}}>
            <CheckBox
              value={isAllowRfsSignoff ? isAllowRfsSignoff.value : false}
              name='rfsSignoff'
              className='siteone-checkbox margin-bottom-0 margin-top-0 pull-left'
              handleChange={this.onChecked}
              checked={isAllowRfsSignoff ? isAllowRfsSignoff.value : false}
              label='Allow RFS Sign off Without resolving WO inside RFS'
            />
            </div>
              <div className='row'>
                <h5 style={{fontWeight: 'bolder', color: 'lightgray', marginLeft: 5}}>Checklist Configuration</h5>
              </div>
              <div className='row'>
                {openCustomTemplate && this.renderSections()}
              </div>
              <div className='row'>
                <button onClick={this.onAddNewSectionBtnClick} className='btn btn-primary btn-siteone-default'>
                  <span className='fa fa-plus icon' /> Add new checklist
                </button>
              </div>
              <br />
              <div className='row'>
                <h5 style={{fontWeight: 'bolder', color: 'lightgray'}}>Text Configuration</h5>
                <div className='disclaimer'>
                  <span>Disclaimer <OverlayTrigger placement='right' overlay={this.toolTipDisclaimer()} delayHide={10} delayShow={500}><i className='fa fa-question-circle' /></OverlayTrigger></span>
                  <div className='disclaimer-textarea'>
                    <InputEditAble
                      changeTextArea={true}
                      disableButtonEdit={true}
                      enableFocusOut={true}
                      defaultValue={this.state.customTemplate && this.state.customTemplate.disclaimerText}
                      autoFocus
                      ignoreRequired={true}
                      inputName= 'disclaimerText'
                      isCapitalize={false}
                      maxLength='524288'
                      onSubmit={this.onEditDisclaimer}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className='row'>
              <div className='col-xs-12' style={{ textAlign: 'left' }}>
                {
                  this.state.customTemplate.sections.length === 0
                    ? <button className='btn btn-primary btn-siteone-default' onClick={this.onClose}>Cancel</button>
                    : <button className='btn btn-primary btn-siteone-default' onClick={() => this.setState({openConfirmModal: true, openModalConfirm: !this.state.openModalConfirm})}>Cancel</button>
                }
                <button disabled={false} style={{ marginLeft: '20px' }} className='btn btn-primary btn-siteone' onClick={this.createTemplate}>Create</button>
              </div>
            </div>
          </Modal.Footer>
          {
            this.state.openRFSSignoffConfirmModal && isAllowRfsSignoff && isAllowRfsSignoff.value&&
            <RFSSignoffModal
            isOpen={this.state.openRFSSignoffConfirmModal}
            onOk={this.onRFSSignoffConfirm}
            onCancel={this.onCancelConfirmModal}
            />
          }
          {
            this.state.openConfirmModal &&
          <ConfirmCancel
            isOpen={this.state.openConfirmModal}
            onOk={this.onClose}
            onCancel={this.onCancelConfirmModal}/>
          }
        </div>
      </Modal>
    );
  }
}

export default TemplateEOCAdd;



// WEBPACK FOOTER //
// ./src/Projects/Components/Template/template-eoc-add.js